import React, { Component } from 'react';
import { Select } from 'antd';
import './public-component.less';

export enum CooperationStates {
    all = -1,
    normal = 0,
    terminated = 1,
}

interface CooperationStatesSelectProps {
    onChange?: (value: number | null) => void;
    showAllOption?: boolean;
    initialValues?: number;
    value?: number;
}

export const getCooperationStates = (states: number) => {
    switch (states) {
        case CooperationStates.normal:
            return '正常';
        case CooperationStates.terminated:
            return '终止';
        default:
            return '其他';
    }
};

class CooperationStatesSelect extends Component<CooperationStatesSelectProps> {
    showAllOption = this.props.showAllOption !== undefined ? this.props.showAllOption : true;

    options = [
        { value: CooperationStates.normal, label: '正常' },
        { value: CooperationStates.terminated, label: '终止' },
    ];

    handleSelectChange = (value: any) => {
        if (this.props.onChange) {
            this.props.onChange(value === CooperationStates.all ? null : value);
        }
    };

    render() {
        const options = this.showAllOption
            ? [{ value: CooperationStates.all, label: '全部' }, ...this.options]
            : this.options;
        const defaultValue = this.props.initialValues !== undefined
            ? this.props.initialValues
            : (this.showAllOption ? CooperationStates.all : CooperationStates.normal);
        const hasValue = this.props.value !== undefined;

        return (
            <Select
                className="select-states"
                onChange={this.handleSelectChange}
                {...(hasValue ? { value: this.props.value } : { defaultValue })}
            >
                {options.map(option => (
                    <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
                ))}
            </Select>
        );
    }
}

export default CooperationStatesSelect;
